import App from '../application.js'

import './setup_i18n'
import '../vendor/bootstrap-datepicker/locales/bootstrap-datepicker.en-GB.js'
import 'moment/locale/en-gb.js'
import './translations.tc.en-GB.js'

$.fn.datepicker.defaults.language = 'en-GB'

I18n.defaultLocale = 'en'
I18n.locale = 'en-GB'

export default App
